function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import emitter from '@/utils/emitter';
import i18n from '../../../utils/i18n';
import { deepClone, generateId } from '../../../utils/util';
import refMixin from '../../../components/form-render/refMixin';
import ContainerItemWrapper from './container-item-wrapper';
import containerItemMixin from './containerItemMixin';
import FieldComponents from '@/components/form-designer/form-widget/field-widget/index';
export default {
  name: 'sub-form-item',
  componentName: 'ContainerItem',
  mixins: [emitter, i18n, refMixin, containerItemMixin],
  components: _objectSpread({
    ContainerItemWrapper: ContainerItemWrapper
  }, FieldComponents),
  props: {
    widget: Object
  },
  inject: ['refList', 'sfRefList', 'globalModel'],
  data: function data() {
    return {
      rowIdData: [],
      fieldSchemaData: [],
      actionDisabled: false
    };
  },
  created: function created() {
    this.initRefList();
    this.registerSubFormToRefList();
    this.initRowIdData(true);
    this.initFieldSchemaData();
    this.initEventHandler();
  },
  mounted: function mounted() {
    this.handleSubFormFirstRowAdd(); //默认添加首行后，主动触发相关事件！！
  },
  beforeDestroy: function beforeDestroy() {
    this.unregisterFromRefList();
  },
  methods: {
    getLabelAlign: function getLabelAlign(widget, subWidget) {
      return subWidget.options.labelAlign || widget.options.labelAlign;
    },
    registerSubFormToRefList: function registerSubFormToRefList() {
      if (this.widget.type === 'sub-form') {
        this.sfRefList[this.widget.options.name] = this;
      }
    },
    initRowIdData: function initRowIdData(initFlag) {
      var _this = this;
      if (this.widget.type === 'sub-form') {
        this.rowIdData.splice(0, this.rowIdData.length); //清除数组必须用splice，length=0不会响应式更新！！
        var subFormModel = this.formModel[this.widget.options.name];
        if (!!subFormModel && subFormModel.length > 0) {
          subFormModel.forEach(function () {
            _this.rowIdData.push('id' + generateId());
          });
          if (!!initFlag) {
            //注意：事件触发需延期执行，SumFormDataChange事件处理代码中可能存在尚未创建完成的组件！！
            setTimeout(function () {
              _this.handleSubFormRowChange(subFormModel);
            }, 800);
          }
        }
      }
    },
    addToRowIdData: function addToRowIdData() {
      this.rowIdData.push('id' + generateId());
    },
    insertToRowIdData: function insertToRowIdData(rowIndex) {
      this.rowIdData.splice(rowIndex, 0, 'id' + generateId());
    },
    deleteFromRowIdData: function deleteFromRowIdData(rowIndex) {
      this.rowIdData.splice(rowIndex, 1);
    },
    getRowIdData: function getRowIdData() {
      return this.rowIdData;
    },
    getWidgetRefOfSubForm: function getWidgetRefOfSubForm(widgetName, rowIndex) {
      var realWidgetName = widgetName + '@row' + this.rowIdData[rowIndex];
      return this.getWidgetRef(realWidgetName);
    },
    initFieldSchemaData: function initFieldSchemaData() {
      var _this2 = this;
      //初始化fieldSchemaData！！！
      if (this.widget.type !== 'sub-form') {
        return;
      }
      var rowLength = this.rowIdData.length;
      this.fieldSchemaData.splice(0, this.fieldSchemaData.length); //清除数组必须用splice，length=0不会响应式更新！！
      if (rowLength > 0) {
        var _loop = function _loop() {
          var fieldSchemas = [];
          _this2.widget.widgetList.forEach(function (swItem) {
            fieldSchemas.push(_this2.cloneFieldSchema(swItem));
          });
          _this2.fieldSchemaData.push(fieldSchemas);
        };
        for (var i = 0; i < rowLength; i++) {
          _loop();
        }
      }
    },
    addToFieldSchemaData: function addToFieldSchemaData(rowIndex) {
      var _this3 = this;
      var fieldSchemas = [];
      this.widget.widgetList.forEach(function (swItem) {
        fieldSchemas.push(_this3.cloneFieldSchema(swItem));
      });
      if (rowIndex === undefined) {
        this.fieldSchemaData.push(fieldSchemas);
      } else {
        this.fieldSchemaData.splice(rowIndex, 0, fieldSchemas);
      }
    },
    deleteFromFieldSchemaData: function deleteFromFieldSchemaData(rowIndex) {
      this.fieldSchemaData.splice(rowIndex, 1);
    },
    cloneFieldSchema: function cloneFieldSchema(fieldWidget) {
      var newFieldSchema = deepClone(fieldWidget);
      newFieldSchema.id = fieldWidget.type + generateId();
      return newFieldSchema;
    },
    initEventHandler: function initEventHandler() {
      var _this4 = this;
      if (this.widget.type !== 'sub-form') {
        return;
      }
      this.$on('setFormData', function (newFormData) {
        _this4.initRowIdData(false);
        _this4.initFieldSchemaData();
        var subFormData = newFormData[_this4.widget.options.name] || [];
        setTimeout(function () {
          //延时触发SubFormRowChange事件, 便于更新计算字段！！
          _this4.handleSubFormRowChange(subFormData);
        }, 800);
      });
    },
    handleSubFormFirstRowAdd: function handleSubFormFirstRowAdd() {
      if (this.widget.type !== 'sub-form') {
        return;
      }
      if (!!this.widget.options.showBlankRow && this.rowIdData.length === 1) {
        var oldSubFormData = this.formModel[this.widget.options.name] || [];
        this.handleSubFormRowAdd(oldSubFormData, this.rowIdData[0]);
        this.handleSubFormRowChange(oldSubFormData);
      }
    },
    addSubFormRow: function addSubFormRow() {
      var newSubFormDataRow = {};
      this.widget.widgetList.forEach(function (subFormItem) {
        if (!!subFormItem.formItemFlag) {
          newSubFormDataRow[subFormItem.options.name] = subFormItem.options.defaultValue;
        }
      });
      var oldSubFormData = this.formModel[this.widget.options.name] || [];
      oldSubFormData.push(newSubFormDataRow);
      this.addToRowIdData();
      this.addToFieldSchemaData();
      this.handleSubFormRowAdd(oldSubFormData, this.rowIdData[oldSubFormData.length - 1]);
      this.handleSubFormRowChange(oldSubFormData);
    },
    insertSubFormRow: function insertSubFormRow(beforeFormRowIndex) {
      var newSubFormDataRow = {};
      this.widget.widgetList.forEach(function (subFormItem) {
        if (!!subFormItem.formItemFlag) {
          newSubFormDataRow[subFormItem.options.name] = subFormItem.options.defaultValue;
        }
      });
      var oldSubFormData = this.formModel[this.widget.options.name] || [];
      oldSubFormData.splice(beforeFormRowIndex, 0, newSubFormDataRow);
      this.insertToRowIdData(beforeFormRowIndex);
      this.addToFieldSchemaData(beforeFormRowIndex);
      this.handleSubFormRowInsert(oldSubFormData, this.rowIdData[beforeFormRowIndex]);
      this.handleSubFormRowChange(oldSubFormData);
    },
    deleteSubFormRow: function deleteSubFormRow(formRowIndex) {
      var _this5 = this;
      this.$confirm(this.i18nt('render.hint.deleteSubFormRow') + '?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function () {
        var oldSubFormData = _this5.formModel[_this5.widget.options.name] || [];
        var deletedDataRow = deepClone(oldSubFormData[formRowIndex]);
        oldSubFormData.splice(formRowIndex, 1);
        _this5.deleteFromRowIdData(formRowIndex);
        _this5.deleteFromFieldSchemaData(formRowIndex);
        _this5.handleSubFormRowDelete(oldSubFormData, deletedDataRow);
        _this5.handleSubFormRowChange(oldSubFormData);
      }).catch(function () {
        //
      });
    },
    handleSubFormRowChange: function handleSubFormRowChange(subFormData) {
      if (!!this.widget.options.onSubFormRowChange) {
        var customFunc = new Function('subFormData', this.widget.options.onSubFormRowChange);
        customFunc.call(this, subFormData);
      }
    },
    handleSubFormRowAdd: function handleSubFormRowAdd(subFormData, newRowId) {
      if (!!this.widget.options.onSubFormRowAdd) {
        var customFunc = new Function('subFormData', 'newRowId', this.widget.options.onSubFormRowAdd);
        customFunc.call(this, subFormData, newRowId);
      }
    },
    handleSubFormRowInsert: function handleSubFormRowInsert(subFormData, newRowId) {
      if (!!this.widget.options.onSubFormRowInsert) {
        var customFunc = new Function('subFormData', 'newRowId', this.widget.options.onSubFormRowInsert);
        customFunc.call(this, subFormData, newRowId);
      }
    },
    handleSubFormRowDelete: function handleSubFormRowDelete(subFormData, deletedDataRow) {
      if (!!this.widget.options.onSubFormRowDelete) {
        var customFunc = new Function('subFormData', 'deletedDataRow', this.widget.options.onSubFormRowDelete);
        customFunc.call(this, subFormData, deletedDataRow);
      }
    }
  }
};